import React, { useRef } from 'react';
import { Upload, Trash2, Loader2 } from 'lucide-react';
import { Button } from './ui/Button';

type Props = {
  label: string;
  value: string;
  uploading?: boolean;
  disabled?: boolean;
  onFileSelected: (file: File) => void | Promise<void>;
  onRemove: () => void;
  /** Vyšší náhled pro hero */
  previewClassName?: string;
};

export function InvitationPhotoUpload({
  label,
  value,
  uploading,
  disabled,
  onFileSelected,
  onRemove,
  previewClassName = 'w-24 h-24',
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="space-y-2">
      <span className="text-ds-meta text-slate-500 dark:text-slate-400 block">{label}</span>
      <div className="flex flex-wrap items-start gap-3">
        {value ? (
          <div
            className={`relative rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 shrink-0 ${previewClassName}`}
          >
            <img src={value} alt="" className="w-full h-full object-cover" />
          </div>
        ) : null}
        <div className="flex flex-col gap-2 min-w-[10rem]">
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            className="sr-only"
            aria-label={label}
            onChange={(e) => {
              const file = e.target.files?.[0];
              e.target.value = '';
              if (file) void onFileSelected(file);
            }}
          />
          <Button
            type="button"
            variant="secondary"
            disabled={disabled || uploading}
            onClick={() => inputRef.current?.click()}
            className="justify-center"
          >
            {uploading ? (
              <Loader2 className="w-4 h-4 animate-spin shrink-0" aria-hidden />
            ) : (
              <Upload className="w-4 h-4 shrink-0" aria-hidden />
            )}
            {uploading ? 'Nahrávám…' : 'Nahrát fotku'}
          </Button>
          {value ? (
            <Button
              type="button"
              variant="ghost"
              className="text-slate-600 dark:text-slate-400 justify-start"
              disabled={disabled || uploading}
              onClick={onRemove}
            >
              <Trash2 className="w-4 h-4 shrink-0" aria-hidden />
              Odstranit
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
